export default __webpack_public_path__ + "static/media/ms_logo.b5d5d067.png";